import { render, staticRenderFns } from "./BlockBlogItem.vue?vue&type=template&id=35e6d441&"
import script from "./BlockBlogItem.vue?vue&type=script&lang=js&"
export * from "./BlockBlogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports